import palette     from './variables.palette.css.mjs';
import typography  from './variables.typography.css.mjs';
import shadows     from './variables.shadows.css.mjs';
import borders     from './variables.borders.css.mjs';
import spacing     from './variables.spacing.css.mjs';
import sizes       from './variables.sizes.css.mjs';
import viewports   from './variables.viewports.css.mjs';
import states      from './variables.states.css.mjs';
import transitions from './variables.transitions.css.mjs';
import components  from './variables.components.css.mjs';
import zindex      from './variables.zindex.css.mjs';
import surface     from './variables.surface.css.mjs';
import dark        from './variables.dark.css.mjs';
import {scrollbarStyles} from './scrollbars.css.mjs';

import { css } from 'lit';

export default css`
  :root {
    /* Native form controls follow color-scheme, not the token layer. Pinned
       light while the OS-preference rule below is disabled; the dark token
       block carries its own color-scheme: dark. At the system-default flip
       this becomes "light dark" so an unset preference follows the OS. */
    color-scheme: light;
    ${palette}
    ${typography}
    ${shadows}
    ${borders}
    ${spacing}
    ${sizes}
    ${viewports}
    ${states}
    ${transitions}
    ${components}
    ${zindex}
    ${surface}
    ${scrollbarStyles}
  }

  /* Dark theme, driven by [data-theme-mode] on the root:
       absent  -> default (see below)
       "light" -> forced light
       "dark"  -> forced dark

     studio-theme-toggle owns that attribute and persists the choice.

     ---------------------------------------------------------------------
     DEV-1166: OS PREFERENCE RULE — currently DISABLED.

     Re-enable by uncommenting the @media block below, at the same time as
     setting SYSTEM_PREFERENCE_ENABLED = true in ./theme-mode.mjs. The two
     must ship together: the flag controls the toggle's options and default,
     this rule controls what an absent attribute paints. Enabling only one
     gives a toggle whose "System" option does nothing, or an OS default the
     toggle cannot represent.

     Why it is off: dark was unreachable before DEV-1166, so no app had been
     exercised in it. An audit of all 23 Studio repos found 366 findings
     (DEV-1166-THEME-AUDIT.md); Publisher, the section-front and content
     editors, Spotlight, Keyword Manager and Alerts are visibly broken. Until
     those are fixed, dark stays opt-in.

     The :not([data-theme-mode="light"]) scope is load-bearing when enabled:
     without it an OS that prefers dark would override a user who explicitly
     chose light. The explicit dark rule below sits last at equal specificity
     (0,2,0) so it wins on order for the mirror case.

     @media (prefers-color-scheme: dark) {
       :root:not([data-theme-mode="light"]) { <dark tokens> }
     }
     --------------------------------------------------------------------- */

  [data-theme-mode="dark"] { ${dark} }
  :root[data-theme-mode="dark"] { ${dark} }
`;
